"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const SwipeableDrawerKTR_1 = __importDefault(require("./SwipeableDrawerKTR"));
const NavigationBarButton_1 = __importDefault(require("./NavigationBarButton"));
const useMobileDevice_1 = __importDefault(require("../Hooks/useMobileDevice"));
const useStyles = core_1.makeStyles((theme) => core_1.createStyles({
    root: {
        flexGrow: 1,
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    title: {
        flexGrow: 1,
    },
    '@media (max-width: 600px)': {
        title: {
            fontSize: "0.9em"
        },
    },
    AppBar: {
        height: "45px",
        marginBottom: "20px",
        zIndex: 1029
    },
    ktrlogo: {
        maxHeight: "50px",
        marginTop: "5px",
        marginBottom: "5px",
        marginLeft: "5px"
    },
    subtitle: {
        fontSize: "0.6em"
    },
    languageSelect: {
        color: "#ffffff",
        border: "none",
        '&:before': {
            border: "none",
        },
        '&:hover:before': {
            border: "none",
            color: "#000000"
        },
        '&:hover:not(.Mui-disabled):before': {
            border: "none"
        }
    }
}));
function Navigation(props) {
    const [isFixed, setIsFixed] = react_1.default.useState(false);
    const matches = core_1.useMediaQuery('(max-width:600px)');
    const isMobileDevice = useMobileDevice_1.default();
    const classes = useStyles();
    react_1.useEffect(() => {
        window.addEventListener('scroll', onScroll);
        return function cleanup() {
            window.removeEventListener('scroll', onScroll);
        };
    }, []);
    const onScroll = function () {
        if (window.scrollY < 156) {
            setIsFixed(false);
        }
        else {
            setIsFixed(true);
        }
    };
    const navButtons = props.navBarButtons.map((btn, index) => {
        return (react_1.default.createElement(NavigationBarButton_1.default, { key: index, Name: btn.Name, NavBarButtonItems: btn.NavBarItems }));
    });
    return (react_1.default.createElement("nav", null,
        react_1.default.createElement(core_1.AppBar, { id: "appBar", className: classes.AppBar, color: "primary", position: isFixed ? "fixed" : "relative" },
            react_1.default.createElement(core_1.Container, null,
                react_1.default.createElement(core_1.Toolbar, { variant: "dense" },
                    (matches || isMobileDevice) ?
                        (react_1.default.createElement(SwipeableDrawerKTR_1.default, { navButtons: props.navBarButtons })) :
                        navButtons,
                    react_1.default.createElement("div", null, matches ? props.collapseContentOnMobile ? "" : props.children : props.children))))));
}
exports.default = Navigation;
//# sourceMappingURL=Navigation.js.map